import { createBrowserRouter } from 'react-router-dom';

import { RequireAuth } from '@/auth/RequireAuth';
import {
  SubscriptionSettings,
  VesselDetailPage,
  VesselListPage,
} from '@/pages/SubscriptionSettings';
import { UnauthorizedPage } from '@/pages/UnauthorizedPage/UnauthorizedPage';
import { ROUTES } from '@/router/routes';

export const router = createBrowserRouter([
  {
    // The settings shell is the layout its two views render into, so the auth gate and the
    // page column are each stated once.
    element: (
      <RequireAuth>
        <SubscriptionSettings />
      </RequireAuth>
    ),
    children: [
      { path: ROUTES.HOME, element: <VesselListPage /> },
      { path: ROUTES.VESSEL, element: <VesselDetailPage /> },
    ],
  },
  {
    path: ROUTES.UNAUTHORIZED,
    element: <UnauthorizedPage />,
  },
]);
